import { Mapper } from '@empathy/search-adapter';
import { Filter } from '@empathy/search-types';
import { injectable } from 'inversify';

@injectable()
export class CdlFilterMapper implements Mapper<Filter> {
  map(rawFilter: any, filter: Filter): Filter {
    filter.title = rawFilter.value;
    return filter;
  }
}
